import { Component } from 'react';
import axios from 'axios';

class Server extends Component {

    authenticationToken: null

    constructor(props) {

        super(props)

        var token = this.getAuthenticationTokenFromLocalStorage();

        if ( (token !== null) && (token !== undefined) && (token !== "") ) {
            this.authenticationToken = token;
        }

    }

    componentDidMount() {

    }

    logout() {
        var myItem = localStorage.getItem('key');
        localStorage.clear();
        localStorage.setItem('key',myItem);
        //localStorage.clear();
        window.location.href = "/";
    }

    api(request, redirect = true) {

        let full = window.location.protocol+'//'+window.location.hostname+(window.location.port ? ':'+window.location.port: '');
        axios.defaults.baseURL = full;

        let headers = {

        }

        if (request.url !== "/api/user/login") {
            headers['Authorization'] = "Token " + this.authenticationToken
        }

        //headers['Authorization'] = "Token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImRvbWluaWsiLCJpZCI6IjViYWE2YzE0ZGQ3YjU3MmQ4MjJhZTcxOSIsImV4cCI6MTU0NTM4MTAzMywiaWF0IjoxNTQwMTkzNDMzfQ.b_7xN-dwgAnVj1_x7Su77AcTACwjxnn5Dr0J91v3nxu";

        axios({
            method: request.method,
            url: request.url,
            data: request.data,
            headers: headers,
        }).then(function (response) {
            request.then(response);
        }.bind(this))
        .catch(function (error) {
            if ( (error.response === undefined) || (error.response.status !== 401) ) {
                request.catch(error);
            } else {
                if(redirect === false) {
                    window.localStorage.removeItem('user');
                    window.localStorage.removeItem('authToken');
                }

                if (!request.ignoreUnauthorized) {

                    if ( (this.authenticationToken !== null) && (this.authenticationToken !== undefined)) {
                        window.location.href = "/401"
                    } else {
                        window.location.href = "/login"
                    }

                }

            }
        }.bind(this));

    }

    getAuthenticationTokenFromLocalStorage = () => {
        return localStorage.getItem('authToken');
    }

    saveAuthenticationTokenToLocalStorage = (token) => {
        localStorage.setItem('authToken', token);
        this.authenticationToken = token;
    }

}

export default Server;



// WEBPACK FOOTER //
// ./src/Server.js